export const SET_AUTHENTICATED = 'App/SET_AUTHENTICATED';
export const SET_ACCESS_TOKEN = 'App/SET_ACCESS_TOKEN';
export const SET_REFRESH_TOKEN = 'App/SET_REFRESH_TOKEN';
export const GET_NEW_TOKEN = 'App/GET_NEW_TOKEN';
export const SET_LOADING_APP = 'App/SET_LOADING_APP';
export const SET_POPUP = 'App/SET_POPUP';



